import React from 'react';

import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

import '../static/styles/ShowcaseCard.css';
import TagPreview from './TagPreview';

export default function ShowcaseCard({data}) {
    const navigate = useNavigate();

    return (
        <Card className="card-content showcase-card mt-5">
            <div className="showcase-card__header">
                <h2 className="mt-0 mb-2">{data.name}</h2>
                <div className="showcase-card__actions">
                    <span className="showcase-card__stars console">
                        <i className="pi pi-star-fill" /> {data.stargazers_count}
                    </span>
                    <Button
                        label="View Project"
                        icon="pi pi-external-link"
                        size="small"
                        outlined
                        rounded
                        onClick={() => {
                            if (!data?.name) {
                                return;
                            }

                            navigate(`/project/${encodeURIComponent(data.name)}`);
                        }}
                    />
                </div>
            </div>

            <p className="gray showcase-card__description">{data.description}</p>
            <div className="card flex flex-wrap gap-2 showcase-card__tags">
                <TagPreview tags={data.topics} />
            </div>
        </Card>
    );
}
